import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2NatureIcon = ({
  color = "currentColor",
  strokeWidth = 1,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 14.474 26.206",
    fill: "none",
    stroke: color,
    strokeWidth: normalizeStrokeWidth(strokeWidth, 26.206),
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "m.501 11.827c-.068 4.023 2.744 8.184 5.623 10.8a1.66 1.66 0 0 0 2.222 0c2.819-2.559 5.7-6.708 5.626-10.8.069-4.092-2.808-8.242-5.626-10.8a1.66 1.66 0 0 0 -2.222 0c-2.879 2.611-5.691 6.776-5.623 10.8z"
    }), /*#__PURE__*/jsx("path", {
      d: "m7.329 8.706v17"
    }), /*#__PURE__*/jsx("path", {
      d: "m7.116 16.362-2.639-2.738"
    }), /*#__PURE__*/jsx("path", {
      d: "m7.444 13.623 2.375-2.8"
    })]
  });
};

export { PM2NatureIcon };
//# sourceMappingURL=nature.js.map
